export const INITIAL_STATE = {  };

export function reducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case "SUBSCRIPTION_DATA_ARRIVED/PORTFOLIOS":
            const payload = action.payload;
            return { ...state, ...payload, failure: null };
        case "SUBSCRIPTION_DATA_FAILED/PORTFOLIOS":
            return { ...state, failure: action.payload };
        case "SUBSCRIPTION_ENDED/PORTFOLIOS":
            return INITIAL_STATE;
        default:
            return state;
    }
}

export default dispatch => ({
});
